export default "__VITE_ASSET__28781b1a__"